import HallOfFame from "../components/pages/HallOfFame";

export default HallOfFame;
